interface Props {
  tone?: "neutral" | "success" | "warning" | "danger" | "info";
  label: string;
  size?: "sm" | "md";
}

const toneStyles: Record<NonNullable<Props["tone"]>, string> = {
  neutral: "bg-slate-100 text-slate-600 border border-slate-200",
  success: "bg-emerald-50 text-emerald-600 border border-emerald-200",
  warning: "bg-amber-50 text-amber-600 border border-amber-200",
  danger: "bg-rose-50 text-rose-600 border border-rose-200",
  info: "bg-indigo-50 text-indigo-600 border border-indigo-200",
};

const sizeStyles: Record<NonNullable<Props["size"]>, string> = {
  sm: "px-2 py-0.5 text-[10px]",
  md: "px-2.5 py-1 text-xs",
};

export default ({ tone = "neutral", size = "md", label }: Props) => {
  return (
    <span className={`inline-flex items-center rounded-full font-medium ${toneStyles[tone]} ${sizeStyles[size]}`}>
      {label}
    </span>
  );
};
